import { render } from "./StatisticQualityItem.vue?vue&type=template&id=1bdb3e14"
import script from "./StatisticQualityItem.vue?vue&type=script&lang=js"
export * from "./StatisticQualityItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__